import { checkDate } from "common/helpers/Date";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const eventResultFromJSON = (json: Partial<IEventResultData>): EventResultRecord => {
  const eventResultData: IEventResultRecord = { ...(json as any) };

  eventResultData.created_at = checkDate(eventResultData.created_at);
  eventResultData.updated_at = checkDate(eventResultData.updated_at);

  return new EventResultRecord(eventResultData);
};

export interface IEventResultData {
  id: number;
  ms_id: string;
  description: string;
  position: number;
  presentation: boolean;
  sold: boolean;
  url: string;
  kind: string;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IEventResultRecord {
  id: number;
  ms_id: string;
  description: string;
  position: number;
  presentation: boolean;
  sold: boolean;
  url: string;
  kind: string;

  created_at: Date;
  updated_at: Date;
}

export const defaultEventResultProps: IEventResultRecord = {
  id: 0,
  ms_id: "",
  description: "",
  position: 0,
  presentation: false,
  sold: false,
  url: "",
  kind: "default",
  created_at: new Date(),
  updated_at: new Date(),
};

export class EventResultRecord extends Record(defaultEventResultProps) implements IEventResultRecord {}
